module.exports = __webpack_public_path__ + "static/media/400072_02.d157ed71.png";